// shared/src/schemas/refresh-snapshot.ts
// Zod schema for `refresh_snapshots` table (D1 migration 0001_init.sql:107-111).
// 3 columns; A2 drift-detector enforces field-name parity.

import { z } from 'zod';

export const RefreshSnapshotSchema = z.object({
  id:         z.string(),
  created_at: z.string().datetime(),
  payload:    z.string(),    // JSON: { macro, ticker_prices, source_status }
});

export type RefreshSnapshot = z.infer<typeof RefreshSnapshotSchema>;
